





























































import AbpBase from "../../../lib/abpbase";
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import {GetAddutyList, InsertAdduty, UpdateAddutyById, DeleteAdduty} from '../../../api/basicDictionary'
import {GetPinYin, GetWuBi} from '../../../api/sys'
@Component
export default class Country extends AbpBase {
	key = '' //查询条件
	page = 1 //当前页
	dialogTitle = ''
	dialogForm: any = {}
	dialogFormVisible = false
	dialogFormLabelWidth = '100px'
	tableTotalSize = 0
	tableData = []
	tableLoading = false
	created() {
		this.getData()
	}
	visibleChange(value: boolean) {
		if (!value) {
			this.$emit('input', value);
			(this.$refs.form as any).resetFields()
		}
	}
	columns = [
		{
			key: 'addutyName',
			title: '职务名称'
		},
		{
			key: 'addutyPY',
			title: '拼音助记符'
		},
		{
			key: 'addutyWB',
			title: '五笔助记符'
		},
		{
			key: 'status',
			title: '是否启用',
			render:(h:any, p:any)=>{
				return h('span', p.row.status ? '启用' : '禁用')
			}
		},
		{
			key: 'spare',
			title: '备注'
		},
		{
			key: '',
			width: 190,
			title: '操作',
			render:(h:any, p:any)=>{
				return h('div', [
					h('Button',{
						props:{type: 'primary'},
						style:{marginRight:'20px'},
						on:{
							click:()=>{
								this.edit(p.row)
							}
						}
					},'编辑'),
					h('Button',{
						props:{type: 'error'},
						on:{
							click:()=>{
								this.del(p.row)
							}
						}
					},'删除'),
				])
			}
		},
	]
	async getCode(val: any){
		let query = {inputStr: val}
		let res1 = await GetPinYin(query)
		let res2 = await GetWuBi(query)
		this.dialogForm.addutyPY = res1
		this.dialogForm.addutyWB = res2
	}
	createCounty() {
		this.dialogTitle = '新增职务'
		this.dialogForm = {status:true,addutyPY:'',addutyWB:''}
		this.dialogFormVisible = true
	}

	private async getData() {
		this.tableLoading = true
		let res = await GetAddutyList({
			QueryString: this.key,
			SkipCount: this.page,
			MaxResultCount: 10
		})
		this.tableData = res.items
		this.tableTotalSize = res.totalCount
		this.tableLoading = false
	}

	handleClose() {
		this.dialogFormVisible = false
	}

	edit(row:any) {
		this.dialogTitle = '编辑职务'
		this.dialogForm = JSON.parse(JSON.stringify(row))
		this.dialogFormVisible = true
	}
	async del(row:any){
		this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
			let res = await DeleteAdduty({Id: row.id})
			this.getData()
		}).catch(() => {
			this.$message({
				type: 'info',
				message: '已取消删除'
			});
		});

	}
	async confirm(){
		(this.$refs.form as any).validate(async (valid:boolean)=>{
			if(valid){
				if (this.dialogTitle === '新增职务') {
					let res = await InsertAdduty(this.dialogForm)
				} else if (this.dialogTitle === '编辑职务') {
					let res = await UpdateAddutyById(this.dialogForm)
				}
				this.dialogFormVisible = false
				this.getData()
			}
		})

	}
	rules = {
		addutyName:[{required: true, message: '请输入内容', trigger: 'blur'}],
		addutyPY:[{required: true, message: '请输入内容', trigger: 'blur'}],
		addutyWB:[{required: true, message: '请输入内容', trigger: 'blur'}],
	}
	pageChange(val:any){
		this.page = val
		this.getData()
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/basicDictionary/adutty/index.vue